const isBackendErrorResponse = (response) => {
  const normalizedResult = String(response?.result || '').toLowerCase();
  const normalizedMessage = String(response?.message || '').toLowerCase();

  return (
    response?.success === false ||
    normalizedResult === 'error' ||
    normalizedMessage.startsWith('ошибка')
  );
};

export const ensureSuccessResponse = (response, fallbackMessage) => {
  if (isBackendErrorResponse(response)) {
    const error = new Error(
      response?.message || fallbackMessage || 'Произошла ошибка'
    );

    error.backendResponse = response;
    throw error;
  }

  return response;
};

export const getBackendErrorResponse = (error) =>
  error?.backendResponse || error?.response?.data;

export const isConflictResponse = (response) =>
  ['409', 'conflict'].includes(
    String(response?.httpStatusCode || '').toLowerCase()
  );
